<template>
    <div id="usergroup-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'User Group',
                    to: { path: '/user-group' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah User Group'
                        : 'Ubah User Group',
                },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah User Group" : "Ubah User Group" }}
        </h3>

        <v-card plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Nama User Group
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Masukkan Nama User Group"
                        outlined
                        v-model="form.user_group_name"
                    ></v-text-field>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pa-0">
                        Deskripsi
                    </v-list-item-title>
                    <v-textarea
                        placeholder="Deskripsi User Group"
                        outlined
                        v-model="form.description"
                    ></v-textarea>
                    <v-checkbox
                        label="Konten Spesifik"
                        v-model="form.is_specific"
                        class="pa-2 ma-0 d-inline-flex"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-card text v-if="$route.query.id" class="mb-5">
                <v-card-text class="ma-0 pa-0">
                    <v-card outlined class="ma-0 pa-0">
                        <v-card-text>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Paket
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <app-datatable
                                :items="packages"
                                :headers="headerPackages"
                                :has-custom-pagination="false"
                                :custom-pagination-per-page="5"
                                :custom-pagination-total-items="packages.length"
                                :custom-pagination-current-page="pageNumber"
                                v-on:changePage="pageNumber = $event"
                            ></app-datatable>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>

            <v-card text v-if="$route.query.id" class="mb-5">
                <v-card-text class="ma-0 pa-0">
                    <v-card outlined class="ma-0 pa-0">
                        <v-card-text>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Konten Spesifik
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <app-datatable
                                :items="contens"
                                :headers="headerContens"
                                :has-custom-pagination="false"
                                :custom-pagination-per-page="5"
                                :custom-pagination-total-items="contens.length"
                                :custom-pagination-current-page="pageNumber"
                                v-on:changePage="pageNumber = $event"
                            ></app-datatable>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
            <v-divider></v-divider>

            <v-card-actions class="py-2">
                <v-spacer></v-spacer>

                <v-btn
                    color="primary"
                    @click="!$route.query.id ? saveData() : editData()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import DataTableContent from "@/modules/global/components/plugins/DataTableContent";
import Spinner from "@/modules/global/components/plugins/Spinner";
import SalesService from "@/modules/global/services/sales.js";

export default {
    name: "usergroup-form",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            packages: [],
            contens: [],
            pageNumber: 1,
            form: {
                user_group_name: "",
                description: "",
                is_specific: false,
            },
            headerPackages: [
                { text: "No.", value: "no" },
                { text: "Nama", value: "name" },
                { text: "Jenjang", value: "level" },
                { text: "Grade", value: "grade" },
            ],
            headerContens: [
                { text: "No.", value: "no" },
                { text: "Nama", value: "name" },
                { text: "Jenjang", value: "level" },
                { text: "Grade", value: "grade" },
                { text: "Jenis", value: "type" },
            ],
        };
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.fetchData();
        }
    },

    methods: {
        fetchData() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getDetailUserGroup(userGroupId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    (context.form.user_group_name =
                        result.data.user_group_name),
                        (context.form.description = result.data.description),
                        (context.form.is_specific = result.data.is_specific);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: result.message,
                        type: "error",
                    });
                }
            });
            this.getPackages();
            this.getContents();
        },

        getPackages() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getPackageByUserGroup(userGroupId, function (result) {
                if (result.success) {
                    context.totalPackage = result.data.total_data;
                    result.data.packages.forEach((items, index) => {
                        var row = {
                            no: index,
                            name: items.package_name,
                            level: items.level,
                            grade: items.grade
                                .sort()
                                .toString()
                                .replace(/[\[\]']+/g, ""),
                        };
                        context.packages.push(row);
                    });
                }
                context.isLoading = false;
            });
        },

        getContents() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getContentByUserGroup(userGroupId, function (result) {
                if (result.success) {
                    // context.totalContent = result.data.total_data;
                    result.data.packages.forEach((items, index) => {
                        var row = {
                            no: index,
                            name: items.content_name,
                            level: items.level,
                            grade: items.grade,
                            type: items.content_type,
                        };
                        context.contens.push(row);
                    });
                }
                context.isLoading = false;
            });
        },

        validateForm: function () {
            var err = false;
            if (
                this.form.user_group_name == null ||
                this.form.user_group_name == "" ||
                this.form.user_group_name == " "
            ) {
                this.$store.commit("showAlert", {
                    message: `Nama User Group wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (
                this.form.description == null ||
                this.form.description == "" ||
                this.form.description == " "
            ) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            return !err;
        },

        saveData: function () {
            if (this.validateForm()) {
                this.isLoading = true;
                var context = this;
                var body = {
                    user_group_name: this.form.user_group_name,
                    description: this.form.description,
                    is_specific: this.form.is_specific,
                };

                SalesService.addUserGroup(body, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: "Berhasil Menyimpan Data!",
                            type: "success",
                        });
                        context.$router.push({ path: "/user-group" });
                    } else {
                        context.$store.commit("showAlert", {
                            message: "Terjadi Kesalahan",
                            type: "error",
                        });
                    }
                });
            }
        },

        editData: function () {
            if (this.validateForm()) {
                this.isLoading = true;
                var context = this;
                var body = {
                    user_group_name: this.form.user_group_name,
                    description: this.form.description,
                    is_specific: this.form.is_specific,
                };

                SalesService.updateUserGroup(
                    this.$route.query.id,
                    body,
                    function (result) {
                        context.isLoading = false;
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: "Data tidak tersimpan",
                                type: "error",
                            });
                        }
                        context.$router.push({ path: "/user-group" });
                    },
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// UserGroupForm.vue?7cda2c32